<template>
  <div v-if="issueItemList !== undefined" class="issueWrap">
    <modals-container/>
    <h1 class="title">ISSUE</h1>
    <!--<issue-item-list :issueItemList="issueItemList"/>-->
    <issue-item-slider
      ref="issue-item-slider"
      :pages="pages"
      :sliderinit="sliderinit"
      @slide="onSlide"
      @tap="onTap"
      @init="onInit"
      @itemOpen="itemOpen"
    />
    <issue-slider-bullets
      :pages="pages.length"
    />

  </div>
</template>

<script>
    import IssueItemList from '@/components/menu/Sunnyfactory/IssueItemList'
    import Slider from 'vue-concise-slider'
    import IssueSliderBullets from '@/components/menu/Sunnyfactory/IssueSliderBullets'

    import { mapGetters , mapState } from 'vuex'
    import IssueItemModal from "./IssueItemModal";

    export default {
        name: "issue" ,
        components : {
          IssueItemModal,
          IssueItemList ,
          'issue-item-slider' : Slider ,
          IssueSliderBullets ,
        } ,
        computed : mapState({
          issueItemList : state => state.issueStore.issues,
          /*pages : function (state) {
            console.log(state.issueStore.issues);
            return this.sliderHtmlInserter(state.issueStore.issues)
          },*/
        }),
        created () {
          this.$store.dispatch('issueStore/getIssues')
            .then( () => {
              if(this.issueItemList != null && this.issueItemList.length > 0) {
                this.pages = this.sliderHtmlInserter(this.issueItemList).map((pageHtml) => {
                  return {
                    html: '<div class="issueBoxList">' + pageHtml.join('') + '</div>',
                    style: {}
                  }
                });
              }
            });

        },
        data () {
          return {
            pages:[],
            interval : 2000 ,
            // Sliding configuration[obj]
            sliderinit: {
              currentPage: 0,
              thresholdDistance: 100,
              thresholdTime: 300,
              loop:true,
              infinite:1,
              slidesToScroll:1
            } ,

          }
        },
        mounted () {
          const sliderPaginationBullets = document.getElementsByClassName('slider-pagination-bullets')[0];
          sliderPaginationBullets.style.display = 'none';
        },
        methods : {
          sliderHtmlGenerator (data) {
            const {title, content , savedUrl , num , thumbnailFileName} = data;
            const htmlStr = [
              `<div class="issueBox" num="${num}">`,
              `<div class="issueThumbnail">`,
              `<img src="//${savedUrl}thumbnail/${thumbnailFileName}"/>`,
              `</div>`,
              `<div class="issueSubject">`,
              `<strong>`,
              `${title}`,
              `</strong>`,
              `</div>`,

              `<div class="issueContent">`,
              `<strong>`,
              `${content}`,
              `</strong>`,
              `</div>`,
              `</div>`,

            ];
            //console.log(htmlStr);
            return htmlStr.join('');
          },
          sliderHtmlInserter (issueItemList) {

            //console.log('issueItemList' , issueItemList);
            const len = issueItemList.length;
            const _pages = [];
            let pageIdx = 0;


            if(issueItemList != null && len > 0) {
              const slideViewMaxCount = 4;
              for(let i = 0 ; i < len; i++) {

                if(_pages[pageIdx] === undefined){
                  _pages[pageIdx] = [];
                }

                _pages[pageIdx].push(this.sliderHtmlGenerator(issueItemList[i]));

                if(i !== 0 && (i + 1) % slideViewMaxCount === 0 ){
                  pageIdx++;
                }
              }

              return _pages;
            }
            else{
              return _pages;
            }

          },
          onSlide (data) {
            let {currentPage} = data;

            currentPage++;
            currentPage = currentPage > this.pages.length || currentPage <= 0 ? 1 : currentPage;
            //console.log('currentPage' , currentPage);
            this.$store.commit('issueSliderBulletStore/slideChange' , {currentPage : currentPage});

          },
          onTap (data) {
            /*const {start} = data;
            const {x , y} = start;
            console.log(x , y);
            console.log(window.event);*/
            const _event = window.event || event ;
            const _target = _event.target;
            const _className = _target.className;

            if(_className !== 'issueBoxList'){

              const issueNum = this.targetFilter(_target) !== undefined && parseInt(this.targetFilter(_target).getAttribute('num'));
              this.itemOpen({
                num : issueNum
              })

              //this.itemOpen();
            }

          },
          onInit (data) {
            //console.log(data);
            //console.log(process.env);
            const { currentPage } = this.$store.state.issueSliderBulletStore;
            //console.log('init CurrentPage : ' , currentPage);
            const _sliderPaginationBullets = document.getElementsByClassName('slider-pagination-bullet');

            for( let i = 0 ; i < _sliderPaginationBullets.length; i++ ) {
              //console.dir(sliderPaginationBullets.children[i]);
              //sliderPaginationBullets.children[i].style.background = '#fff none repeat scroll 0 0;'
              _sliderPaginationBullets[i].style.opacity = '1';
              Object.assign(_sliderPaginationBullets[i].style , this.sliderBulletsStyleSetter(_sliderPaginationBullets[i].classList.contains('slider-pagination-bullet-active')));
            }
          },
          targetFilter (target) {
            const _containTagName = ['IMG' , 'STRONG' ];
            let returnTarget;

            if(_containTagName.find( (n) => {
                return n === target.tagName
              }) !== undefined){
              //console.log(target , target.className === 'issueBox');
              returnTarget = target.parentElement.parentElement;

            }else if('DIV' === target.tagName && target.className !== 'issueBox'){
              returnTarget = target.parentElement;
            }else{
              //console.log(target , target.className === 'issueBox');
              returnTarget = target;
            }


            return returnTarget;

          },
          itemOpen ( {num} ) {
            const item = this.issueItemList.find( (n) => n.num === num);

            const clientWidth = document.body.clientWidth;
            const clientHeight = document.body.clientHeight;

            this.$modal.show(IssueItemModal , {
                item: item ,
              }, {
                /*resizable : true ,*/
                draggable: true ,
                width : clientWidth * (clientWidth <= 767 ? 0.8 : 0.4),
                height : clientHeight * 0.8 ,
            })
          },
        },
    }
</script>

<style lang="scss">
  @import "@/styles/Sunnyfactory.scss";

</style>



// WEBPACK FOOTER //
// src/components/menu/Sunnyfactory/Issue.vue